// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionPayload, unionToActionPayload, unionListToActionPayload } from '../tbs/action-payload.js';
import { AddPlayerAction, AddPlayerActionT } from '../tbs/add-player-action.js';
import { CancelFactoryOrderAction, CancelFactoryOrderActionT } from '../tbs/cancel-factory-order-action.js';
import { ClaimPlayerSlotAction, ClaimPlayerSlotActionT } from '../tbs/claim-player-slot-action.js';
import { DeleteLobbyAction, DeleteLobbyActionT } from '../tbs/delete-lobby-action.js';
import { DeleteMapAction, DeleteMapActionT } from '../tbs/delete-map-action.js';
import { DeletePlayerAction, DeletePlayerActionT } from '../tbs/delete-player-action.js';
import { EndGameAction, EndGameActionT } from '../tbs/end-game-action.js';
import { EndRoundAction, EndRoundActionT } from '../tbs/end-round-action.js';
import { EndTurnAction, EndTurnActionT } from '../tbs/end-turn-action.js';
import { Entity, EntityT } from '../tbs/entity.js';
import { EraseTileAction, EraseTileActionT } from '../tbs/erase-tile-action.js';
import { InvitePlayerSlotAction, InvitePlayerSlotActionT } from '../tbs/invite-player-slot-action.js';
import { KickPlayerSlotAction, KickPlayerSlotActionT } from '../tbs/kick-player-slot-action.js';
import { LeavePlayerSlotAction, LeavePlayerSlotActionT } from '../tbs/leave-player-slot-action.js';
import { MapToLobbyAction, MapToLobbyActionT } from '../tbs/map-to-lobby-action.js';
import { MoveUnitAction, MoveUnitActionT } from '../tbs/move-unit-action.js';
import { PaintTileAction, PaintTileActionT } from '../tbs/paint-tile-action.js';
import { PatchConfigAction, PatchConfigActionT } from '../tbs/patch-config-action.js';
import { PatchMapAction, PatchMapActionT } from '../tbs/patch-map-action.js';
import { PatchPlayerAction, PatchPlayerActionT } from '../tbs/patch-player-action.js';
import { PatchPlayerSlotAction, PatchPlayerSlotActionT } from '../tbs/patch-player-slot-action.js';
import { PlaceFactoryOrderAction, PlaceFactoryOrderActionT } from '../tbs/place-factory-order-action.js';
import { Position, PositionT } from '../tbs/position.js';
import { PublishMapAction, PublishMapActionT } from '../tbs/publish-map-action.js';
import { ReservePlayerSlotAction, ReservePlayerSlotActionT } from '../tbs/reserve-player-slot-action.js';
import { RestoreLobbyAction, RestoreLobbyActionT } from '../tbs/restore-lobby-action.js';
import { RestoreMapAction, RestoreMapActionT } from '../tbs/restore-map-action.js';
import { RotateEntityAction, RotateEntityActionT } from '../tbs/rotate-entity-action.js';
import { RownipulatorAddRowAction, RownipulatorAddRowActionT } from '../tbs/rownipulator-add-row-action.js';
import { RownipulatorDeleteRowAction, RownipulatorDeleteRowActionT } from '../tbs/rownipulator-delete-row-action.js';
import { RownipulatorDuplicateRowAction, RownipulatorDuplicateRowActionT } from '../tbs/rownipulator-duplicate-row-action.js';
import { SetBotPlayerSlotAction, SetBotPlayerSlotActionT } from '../tbs/set-bot-player-slot-action.js';
import { SetEntityElevationAction, SetEntityElevationActionT } from '../tbs/set-entity-elevation-action.js';
import { SetEntsAction, SetEntsActionT } from '../tbs/set-ents-action.js';
import { SetStateAction, SetStateActionT } from '../tbs/set-state-action.js';
import { StartNewGameAction, StartNewGameActionT } from '../tbs/start-new-game-action.js';
import { StartRoundAction, StartRoundActionT } from '../tbs/start-round-action.js';
import { StartTurnAction, StartTurnActionT } from '../tbs/start-turn-action.js';
import { State, StateT } from '../tbs/state.js';
import { SwapPlayerSlotAction, SwapPlayerSlotActionT } from '../tbs/swap-player-slot-action.js';
import { UnpublishMapAction, UnpublishMapActionT } from '../tbs/unpublish-map-action.js';


export class ActionLog implements flatbuffers.IUnpackableObject<ActionLogT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ActionLog {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsActionLog(bb:flatbuffers.ByteBuffer, obj?:ActionLog):ActionLog {
  return (obj || new ActionLog()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsActionLog(bb:flatbuffers.ByteBuffer, obj?:ActionLog):ActionLog {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ActionLog()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

round():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

cref():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

at():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('0');
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

actionType():ActionPayload {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActionPayload.NONE;
}

action<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

unit0(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

unit1(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

target0(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

target1(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

destPositionSteps(index: number, obj?:Position):Position|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? (obj || new Position()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

destPositionStepsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

annexed0(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

annexed1(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

cargo0(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

cargo1(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 32);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

taxi0(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 34);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

taxi1(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 36);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

merge0(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 38);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

merge1(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 40);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

factory0(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

state0(obj?:State):State|null {
  const offset = this.bb!.__offset(this.bb_pos, 44);
  return offset ? (obj || new State()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

gameEnded():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 46);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

static startActionLog(builder:flatbuffers.Builder) {
  builder.startObject(22);
}

static addRound(builder:flatbuffers.Builder, round:number) {
  builder.addFieldInt32(0, round, 0);
}

static addCref(builder:flatbuffers.Builder, cref:number) {
  builder.addFieldInt16(1, cref, 0);
}

static addAt(builder:flatbuffers.Builder, at:bigint) {
  builder.addFieldInt64(2, at, BigInt('0'));
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt32(3, playerId, -1);
}

static addActionType(builder:flatbuffers.Builder, actionType:ActionPayload) {
  builder.addFieldInt8(4, actionType, ActionPayload.NONE);
}

static addAction(builder:flatbuffers.Builder, actionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, actionOffset, 0);
}

static addUnit0(builder:flatbuffers.Builder, unit0Offset:flatbuffers.Offset) {
  builder.addFieldOffset(6, unit0Offset, 0);
}

static addUnit1(builder:flatbuffers.Builder, unit1Offset:flatbuffers.Offset) {
  builder.addFieldOffset(7, unit1Offset, 0);
}

static addTarget0(builder:flatbuffers.Builder, target0Offset:flatbuffers.Offset) {
  builder.addFieldOffset(8, target0Offset, 0);
}

static addTarget1(builder:flatbuffers.Builder, target1Offset:flatbuffers.Offset) {
  builder.addFieldOffset(9, target1Offset, 0);
}

static addDestPositionSteps(builder:flatbuffers.Builder, destPositionStepsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(10, destPositionStepsOffset, 0);
}

static createDestPositionStepsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startDestPositionStepsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addAnnexed0(builder:flatbuffers.Builder, annexed0Offset:flatbuffers.Offset) {
  builder.addFieldOffset(11, annexed0Offset, 0);
}

static addAnnexed1(builder:flatbuffers.Builder, annexed1Offset:flatbuffers.Offset) {
  builder.addFieldOffset(12, annexed1Offset, 0);
}

static addCargo0(builder:flatbuffers.Builder, cargo0Offset:flatbuffers.Offset) {
  builder.addFieldOffset(13, cargo0Offset, 0);
}

static addCargo1(builder:flatbuffers.Builder, cargo1Offset:flatbuffers.Offset) {
  builder.addFieldOffset(14, cargo1Offset, 0);
}

static addTaxi0(builder:flatbuffers.Builder, taxi0Offset:flatbuffers.Offset) {
  builder.addFieldOffset(15, taxi0Offset, 0);
}

static addTaxi1(builder:flatbuffers.Builder, taxi1Offset:flatbuffers.Offset) {
  builder.addFieldOffset(16, taxi1Offset, 0);
}

static addMerge0(builder:flatbuffers.Builder, merge0Offset:flatbuffers.Offset) {
  builder.addFieldOffset(17, merge0Offset, 0);
}

static addMerge1(builder:flatbuffers.Builder, merge1Offset:flatbuffers.Offset) {
  builder.addFieldOffset(18, merge1Offset, 0);
}

static addFactory0(builder:flatbuffers.Builder, factory0Offset:flatbuffers.Offset) {
  builder.addFieldOffset(19, factory0Offset, 0);
}

static addState0(builder:flatbuffers.Builder, state0Offset:flatbuffers.Offset) {
  builder.addFieldOffset(20, state0Offset, 0);
}

static addGameEnded(builder:flatbuffers.Builder, gameEnded:boolean) {
  builder.addFieldInt8(21, +gameEnded, +false);
}

static endActionLog(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): ActionLogT {
  return new ActionLogT(
    this.round(),
    this.cref(),
    this.at(),
    this.playerId(),
    this.actionType(),
    (() => {
      const temp = unionToActionPayload(this.actionType(), this.action.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })(),
    (this.unit0() !== null ? this.unit0()!.unpack() : null),
    (this.unit1() !== null ? this.unit1()!.unpack() : null),
    (this.target0() !== null ? this.target0()!.unpack() : null),
    (this.target1() !== null ? this.target1()!.unpack() : null),
    this.bb!.createObjList<Position, PositionT>(this.destPositionSteps.bind(this), this.destPositionStepsLength()),
    (this.annexed0() !== null ? this.annexed0()!.unpack() : null),
    (this.annexed1() !== null ? this.annexed1()!.unpack() : null),
    (this.cargo0() !== null ? this.cargo0()!.unpack() : null),
    (this.cargo1() !== null ? this.cargo1()!.unpack() : null),
    (this.taxi0() !== null ? this.taxi0()!.unpack() : null),
    (this.taxi1() !== null ? this.taxi1()!.unpack() : null),
    (this.merge0() !== null ? this.merge0()!.unpack() : null),
    (this.merge1() !== null ? this.merge1()!.unpack() : null),
    (this.factory0() !== null ? this.factory0()!.unpack() : null),
    (this.state0() !== null ? this.state0()!.unpack() : null),
    this.gameEnded()
  );
}


unpackTo(_o: ActionLogT): void {
  _o.round = this.round();
  _o.cref = this.cref();
  _o.at = this.at();
  _o.playerId = this.playerId();
  _o.actionType = this.actionType();
  _o.action = (() => {
      const temp = unionToActionPayload(this.actionType(), this.action.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
  _o.unit0 = (this.unit0() !== null ? this.unit0()!.unpack() : null);
  _o.unit1 = (this.unit1() !== null ? this.unit1()!.unpack() : null);
  _o.target0 = (this.target0() !== null ? this.target0()!.unpack() : null);
  _o.target1 = (this.target1() !== null ? this.target1()!.unpack() : null);
  _o.destPositionSteps = this.bb!.createObjList<Position, PositionT>(this.destPositionSteps.bind(this), this.destPositionStepsLength());
  _o.annexed0 = (this.annexed0() !== null ? this.annexed0()!.unpack() : null);
  _o.annexed1 = (this.annexed1() !== null ? this.annexed1()!.unpack() : null);
  _o.cargo0 = (this.cargo0() !== null ? this.cargo0()!.unpack() : null);
  _o.cargo1 = (this.cargo1() !== null ? this.cargo1()!.unpack() : null);
  _o.taxi0 = (this.taxi0() !== null ? this.taxi0()!.unpack() : null);
  _o.taxi1 = (this.taxi1() !== null ? this.taxi1()!.unpack() : null);
  _o.merge0 = (this.merge0() !== null ? this.merge0()!.unpack() : null);
  _o.merge1 = (this.merge1() !== null ? this.merge1()!.unpack() : null);
  _o.factory0 = (this.factory0() !== null ? this.factory0()!.unpack() : null);
  _o.state0 = (this.state0() !== null ? this.state0()!.unpack() : null);
  _o.gameEnded = this.gameEnded();
}
}

export class ActionLogT implements flatbuffers.IGeneratedObject {
constructor(
  public round: number = 0,
  public cref: number = 0,
  public at: bigint = BigInt('0'),
  public playerId: number = -1,
  public actionType: ActionPayload = ActionPayload.NONE,
  public action: AddPlayerActionT|CancelFactoryOrderActionT|ClaimPlayerSlotActionT|DeleteLobbyActionT|DeleteMapActionT|DeletePlayerActionT|EndGameActionT|EndRoundActionT|EndTurnActionT|EraseTileActionT|InvitePlayerSlotActionT|KickPlayerSlotActionT|LeavePlayerSlotActionT|MapToLobbyActionT|MoveUnitActionT|PaintTileActionT|PatchConfigActionT|PatchMapActionT|PatchPlayerActionT|PatchPlayerSlotActionT|PlaceFactoryOrderActionT|PublishMapActionT|ReservePlayerSlotActionT|RestoreLobbyActionT|RestoreMapActionT|RotateEntityActionT|RownipulatorAddRowActionT|RownipulatorDeleteRowActionT|RownipulatorDuplicateRowActionT|SetBotPlayerSlotActionT|SetEntityElevationActionT|SetEntsActionT|SetStateActionT|StartNewGameActionT|StartRoundActionT|StartTurnActionT|SwapPlayerSlotActionT|UnpublishMapActionT|null = null,
  public unit0: EntityT|null = null,
  public unit1: EntityT|null = null,
  public target0: EntityT|null = null,
  public target1: EntityT|null = null,
  public destPositionSteps: (PositionT)[] = [],
  public annexed0: EntityT|null = null,
  public annexed1: EntityT|null = null,
  public cargo0: EntityT|null = null,
  public cargo1: EntityT|null = null,
  public taxi0: EntityT|null = null,
  public taxi1: EntityT|null = null,
  public merge0: EntityT|null = null,
  public merge1: EntityT|null = null,
  public factory0: EntityT|null = null,
  public state0: StateT|null = null,
  public gameEnded: boolean = false
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const action = builder.createObjectOffset(this.action);
  const unit0 = (this.unit0 !== null ? this.unit0!.pack(builder) : 0);
  const unit1 = (this.unit1 !== null ? this.unit1!.pack(builder) : 0);
  const target0 = (this.target0 !== null ? this.target0!.pack(builder) : 0);
  const target1 = (this.target1 !== null ? this.target1!.pack(builder) : 0);
  const destPositionSteps = ActionLog.createDestPositionStepsVector(builder, builder.createObjectOffsetList(this.destPositionSteps));
  const annexed0 = (this.annexed0 !== null ? this.annexed0!.pack(builder) : 0);
  const annexed1 = (this.annexed1 !== null ? this.annexed1!.pack(builder) : 0);
  const cargo0 = (this.cargo0 !== null ? this.cargo0!.pack(builder) : 0);
  const cargo1 = (this.cargo1 !== null ? this.cargo1!.pack(builder) : 0);
  const taxi0 = (this.taxi0 !== null ? this.taxi0!.pack(builder) : 0);
  const taxi1 = (this.taxi1 !== null ? this.taxi1!.pack(builder) : 0);
  const merge0 = (this.merge0 !== null ? this.merge0!.pack(builder) : 0);
  const merge1 = (this.merge1 !== null ? this.merge1!.pack(builder) : 0);
  const factory0 = (this.factory0 !== null ? this.factory0!.pack(builder) : 0);
  const state0 = (this.state0 !== null ? this.state0!.pack(builder) : 0);

  ActionLog.startActionLog(builder);
  ActionLog.addRound(builder, this.round);
  ActionLog.addCref(builder, this.cref);
  ActionLog.addAt(builder, this.at);
  ActionLog.addPlayerId(builder, this.playerId);
  ActionLog.addActionType(builder, this.actionType);
  ActionLog.addAction(builder, action);
  ActionLog.addUnit0(builder, unit0);
  ActionLog.addUnit1(builder, unit1);
  ActionLog.addTarget0(builder, target0);
  ActionLog.addTarget1(builder, target1);
  ActionLog.addDestPositionSteps(builder, destPositionSteps);
  ActionLog.addAnnexed0(builder, annexed0);
  ActionLog.addAnnexed1(builder, annexed1);
  ActionLog.addCargo0(builder, cargo0);
  ActionLog.addCargo1(builder, cargo1);
  ActionLog.addTaxi0(builder, taxi0);
  ActionLog.addTaxi1(builder, taxi1);
  ActionLog.addMerge0(builder, merge0);
  ActionLog.addMerge1(builder, merge1);
  ActionLog.addFactory0(builder, factory0);
  ActionLog.addState0(builder, state0);
  ActionLog.addGameEnded(builder, this.gameEnded);

  return ActionLog.endActionLog(builder);
}
}
